import styled from 'styled-components';

export const Contant = styled.div`
    max-width: 1200px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 0;

    h1 {
        color: var(--dark);
        text-decoration: none;
        font-weight: 700;
        font-size: 28px;
        font-family: Roboto, sans-serif;
    }

    h2 {
        color: var(--dark);
        text-decoration: none;
        font-weight: 700;
        font-size: 18px;
        font-family: Roboto, sans-serif;
    }
`;
